export enum ConnectionTypeEnum {
  SELECT = -1,
  NETWORK = 1,
  FTP = 2,
  LOCAL_DIRECTORY = 3,
  SFTP = 4,
}
